import qs from 'qs';
import instance from '../axios';

export const getBasePrices = () => {
  return instance.get('/catalogs/basePrice');
};

export const getHistoricBasePrices = () => {
  return instance.get('/catalogs/basePrice/historic');
}
